import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import './App.css';
import Footer from './Footer';
import Topbar from './Topbar';
import Home from './pages/Home';
import { Link, Route, Routes, useLocation } from "react-router-dom"
import Projects from './pages/Projects';
import Research from './pages/Research';
import AboutMe from './pages/AboutMe';
import Contact from './pages/Contact';

const languages = {
  "Belarus": "RU",
  "Russia": "RU",
  "Czechia": "CZ",
  "Greece": "GR",
  "Cyprus": "GR",
}

const pageVariants = {
  hidden: {
    opacity: 0,
    filter: 'blur(10px)',
  },
  visible: {
    opacity: 1,
    filter: 'blur(0px)',
    transition: { duration: 0.3 },
  },
  exit: {
    opacity: 0,
    filter: 'blur(10px)',
    transition: { duration: 0.3 },
  },
};

const translations = {
  "name" : { "EN": <>Nikitas Marmatakis</>, "RU": <>Никитас Марматакис</>, "CZ": <>Nikitas Marmatakis</>, "GR": <>Νικήτας Μαρματάκης</> },
  "Nikitas Marmatakis": { "EN": <>Nikitas <br /> Marmatakis</>, "RU": <>Никитас <br /> Марматакис</>, "CZ": <>Nikitas <br /> Marmatakis</>, "GR": <>Νικήτας <br /> Μαρματάκης</> },
  "desc": {
    "EN": <> <Link className="link underline">Software Engineer</Link> & CS student <br/> I have a huge passion for technology</>,
  },
  "Contact me": { "EN": "Contact me"}
}

function App() {
  const [lang, setLang] = useState("EN");
  const [country, setCountry] = useState("United States");
  const [path, setPath] = useState("");
  const [theme, setTheme] = useState("dark");
  const [mobileMenu, setMobileMenu] = useState(false);
  const global = {
    "country": [country, setCountry],
    "lang": [lang, setLang],
    "path": path,
    "theme": [theme, setTheme],
    "mobileMenu": [mobileMenu, setMobileMenu],
    "page_titles": {
      "/": "Home",
      "/projects": "Projects",
      "/research": "Research",
      "/about-me": "About me",
      "/contact": "Contact"
    },
    "translations": translations,
  }
  const location = useLocation();

  useEffect(() => {
    setPath(location.pathname);
  }, [location]);

  // useEffect(() => {
  //   fetch('http://ip-api.com/json')
  //     .then(res => res.json())
  //     .then(response => {
  //       if (response && response.country) {
  //         setCountry(response.country);
  //         if (response.country in languages) {
  //           setLang(languages[response.country])
  //         }
  //       }
  //     })
  // }, []);
  return (
    <>
      <main className={theme}>
        {/* <Topbar global={global} /> */}
        {/* <AnimatePresence exitBeforeEnter>
          <Routes location={location} key={location.key}>
            <Route path="/" element={
              <motion.div
                variants={pageVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                className="motion-div"
              > */}
                <Home global={global} />
              {/* </motion.div>
            } />
            <Route path="/projects" element={
              <motion.div
                variants={pageVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              >
                <Projects global={global} />
              </motion.div>} />
            <Route path="/research" element={
              <motion.div
                variants={pageVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              ><Research global={global} /></motion.div>} />
            <Route path="/about-me" element={<AboutMe global={global} />} />
            <Route path="/contact" element={<Contact global={global} />} />
          </Routes>
        </AnimatePresence> */}
      </main>
      {/* <Footer lang={[lang, setLang]} global={global}/> */}
    </>
  );
}

export default App;
